"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwentyOneGameState = void 0;
const logic_types_1 = require("./logic-types");
const common_1 = require("../../common");
const logic_metrics_1 = require("./logic-metrics");
class TwentyOneGameState {
    get currentScoreData() {
        return {
            score: this.totalScore,
        };
    }
    constructor(logicEventQueue, analyticsData) {
        this.logicEventQueue = logicEventQueue;
        this.analyticsData = analyticsData;
        this.roundState = logic_types_1.RoundState.Loading;
        this.totalScore = 0;
        this.clearStreak = 0;
    }
    initGame(instant) {
        this.setRoundState(logic_types_1.RoundState.Deal, instant);
    }
    reset() {
        this.roundState = logic_types_1.RoundState.Loading;
    }
    getRoundState() {
        return this.roundState;
    }
    setRoundState(state, instant) {
        this.roundState = state;
        this.logicEventQueue.enqueue({
            type: "onRoundStateChanged",
            instant,
            payload: { state },
        });
    }
    sendPlayerActionResult(cardColumn, result, instant) {
        switch (result) {
            case logic_types_1.PlayerActionResult.Stack:
                {
                    const stackPoints = logic_metrics_1.LogicMetrics.StackCardPoints;
                    this.addScore(stackPoints);
                    this.logicEventQueue.enqueue({
                        type: "onColumnResult",
                        instant,
                        payload: {
                            cardColumn: cardColumn.clone(),
                            result: result,
                            points: stackPoints,
                        },
                    });
                }
                break;
            case logic_types_1.PlayerActionResult.Bust:
                {
                    const bustPoints = logic_metrics_1.LogicMetrics.ColumnBustPoints;
                    this.removeScore(bustPoints);
                    this.analyticsData.totalColumnsBusted++;
                    this.clearStreak = 0;
                    this.logicEventQueue.enqueue({
                        type: "onColumnResult",
                        instant,
                        payload: {
                            cardColumn: cardColumn.clone(),
                            result: result,
                            points: bustPoints * -1, // Make these negative
                        },
                    });
                }
                break;
            case logic_types_1.PlayerActionResult.ReachedTarget:
            case logic_types_1.PlayerActionResult.Wild:
                {
                    const targetPoints = logic_metrics_1.LogicMetrics.ColumnTargetPointsPerCard * cardColumn.cardCount;
                    this.addScore(targetPoints);
                    this.clearStreak++;
                    this.analyticsData.totalColumnsCleared++;
                    this.analyticsData.maxColumnScore = Math.max(this.analyticsData.maxColumnScore, targetPoints);
                    this.analyticsData.maxClearStreak = Math.max(this.analyticsData.maxClearStreak, this.clearStreak);
                    this.logicEventQueue.enqueue({
                        type: "onColumnResult",
                        instant,
                        payload: {
                            cardColumn: cardColumn.clone(),
                            result: result,
                            points: targetPoints,
                        },
                    });
                }
                break;
            default:
                (0, common_1.assertNever)(result, "Invalid player action result");
        }
    }
    addScore(value) {
        this.totalScore += value;
        this.emitScoreChange();
    }
    removeScore(value) {
        this.totalScore -= value;
        // Don't allow the score to drop below zero
        if (this.totalScore < 0) {
            this.totalScore = 0;
        }
        this.emitScoreChange();
    }
    emitScoreChange() {
        this.analyticsData.finalScore = this.totalScore;
        this.analyticsData.maxScore = Math.max(this.analyticsData.maxScore, this.totalScore);
        this.logicEventQueue.enqueue({
            type: "onScoreChanged",
            instant: false,
            payload: { value: this.totalScore },
        });
    }
}
exports.TwentyOneGameState = TwentyOneGameState;
